import styled from 'styled-components'

import FormFieldInput from '../FormFieldInput'
import { Wrapper } from '../FormFieldInput/styled'

export const Input = styled(FormFieldInput)``

export const AutoSuggest = styled.div`
  & .react-autosuggest__container {
    position: relative;
    z-index: ${({ theme }) => theme.zIndexes.autoSuggestOpen};
  }

  & .react-autosuggest__container--open {
    & ${Wrapper} {
      border-bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  & .react-autosuggest__input--focused {
    outline: none;
  }

  & .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  & .react-autosuggest__suggestions-container {
    display: none;
  }

  & .react-autosuggest__suggestions-container--open {
    ${({ theme }) => theme.textStyles.montserratSmMedium};
    display: block;
    width: 100%;
    position: absolute;
    top: 100%;
    border: 1px solid ${({ theme }) => theme.colors.bismark};
    color: ${({ theme }) => theme.colors.greyContour};
    border-top: 0;
    background-color: #fff;
    font-family: montserraica, sans-serif;
    font-weight: 300;
    font-size: 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    overflow: hidden;
    padding-top: 1rem;

    &:before {
      position: absolute;
      content: '';
      background-color: ${({ theme }) => theme.colors.bismark};
      height: 1px;
      left: 1rem;
      right: 1rem;
      top: 0;
    }
  }

  & .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    max-height: 200px;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  & .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }

  & .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }
`
